/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-26 19:48:48
 * @LastEditTime: 2022-05-26 18:20:52
 * @LastEditors: haima haima@yaomaitong.cn
 */
import request from '@/utils/request'
import { API } from './apiConfig'
import { md5 } from '@/utils/util'

export function getDoctorInfo() {
  return request({
    url: API.getDoctorInfo,
    method: 'get'
  })
}
export function getRepresentUserDetail() {
  return request({
    url: API.getRepresentUserDetail,
    method: 'get'
  })
}
export function getUvipInfo() {
  return request({
    url: API.getUvipInfo,
    method: 'get'
  })
}

export function getSpeakerDetail(doctorId = '') {
  return request({
    method: 'get',
    url: API.getSpeakerDetail,
    params: {
      doctorId
    }
  })
}

export function getRepresentInfo(representId = '') {
  return request({
    method: 'get',
    url: API.representInfo,
    params: {
      representId: representId
    }
  })
}

export function userLogin(mobile = '', representId = '', smsCaptcha = '', doctorId = '', orgIds = []) {
  return request({
    url: API.userLogin,
    method: 'post',
    data: {
      // requestObj: {
      mobile: mobile,
      representId: representId,
      smsCaptcha: smsCaptcha,
      doctorId: doctorId,
      orgIds: orgIds,
      // }
    }
  })
}

export function getUserRecallGiftList({ flowType = 1, pageNo = 1, pageSize = 20 }) {
  return request({
    url: API.getUserRecallGiftList,
    method: 'get',
    params: { flowType, pageSize, pageNo }
  })
}

export function getUserSupportDetail() {
  return request({
    url: API.getUserSupportDetail,
    method: 'get',
  })
}

export function onApplyUserUnseal(req) {
  // 申请解冻
  return request({
    url: API.onApplyUserUnseal,
    method: 'get',
    params: req
  })
}
export function onValidUserMobile(mobile) {
  // 申请解冻
  return request({
    url: API.onValidUserMobile,
    method: 'get',
    params: { mobile }
  })
}
export function setFaceAuthUpdateMobile({ orderNo = '', newMobile = '', smsCaptcha = '' }) {
  return request({
    url: API.setFaceAuthUpdateMobile,
    method: 'get',
    params: {
      orderNo,
      newMobile,
      smsCaptcha
    }
  })
}

export function setUnLoginFaceAuthUpdateMobile({ tmpId = '', newMobile = '', smsCaptcha = '', orderNo = '' }) {
  return request({
    url: API.setUnLoginFaceAuthUpdateMobile,
    method: 'get',
    params: {
      tmpId,
      newMobile,
      smsCaptcha,
      orderNo
    }
  })
}
export function setVerifyCodeUpdateMobile(oldMobile = '', oldCode = '', newMobile = '', newCode = '') {
  return request({
    url: API.setVerifyCodeUpdateMobile,
    method: 'get',
    params: {
      oldMobile: oldMobile,
      oldCode: oldCode,
      newMobile: newMobile,
      newCode: newCode
    }
  })
}
export function userBind(representId = '', targetOrgIds = []) {
  return request({
    url: API.UserBind,
    method: 'post',
    data: {
      representId,
      targetOrgIds
    }
  })
}

export function updateUserInfo(user) {
  return request({
    url: API.updateUserInfo,
    method: 'post',
    params: {
      name: user.name,
      mobile: user.mobile,
      department: user.department,
      hospital: user.hospital
    }
  })
}

export function onAgreeNotify(notifyType = 6) {
  return request({
    url: API.onAgreeNotify,
    method: 'get',
    params: { notifyType }
  })
}
export function getUserNotify(types = '') {
  return request({
    url: API.getUserNotify,
    method: 'post',
    data: types
  })
}
export function getAuthRejectReason(auditType = 0) {
  return request({
    url: API.getAuthRejectReason,
    method: 'get',
    params: { auditType }
  })
}
export function uploadAuth(req) {
  return request({
    url: API.uploadAuth,
    method: 'post',
    data: req
  })
}

/**
 * OCR 识别执业证书
 * @param {Object} params - 请求参数
 * @param {Array<String>} params.imageUrls - 证书图片URL列表（简短路径），支持多张：[编码页, 变更页]
 * @returns {Promise<{doctorName: string, certificateNo: string, isValid: boolean, errorMessage: string}>}
 */
export function ocrRecognizeLicense(params) {
  return request({
    url: API.ocrRecognizeLicense,
    method: 'post',
    data: params
  })
}

/**
 * OCR 识别职称证明
 * @param {Object} params - 请求参数
 * @param {String} params.imageUrl - 职称证明图片URL（简短路径）
 * @returns {Promise<{title: string}>}
 */
export function ocrRecognizeTitle(params) {
  return request({
    url: API.ocrRecognizeTitle,
    method: 'post',
    data: params
  })
}
export function hasBindRep() {
  return request({
    url: API.hasBindRep,
    method: 'get'
  })
}
export function realNameAuthCount() {
  return request({
    url: API.realNameAuthCount,
    method: 'get'
  })
}
//新的获取验证码
export function getVerifyCode({ mobile, smsType, isVoice = false }) {
  return request({
    method: 'get',
    url: API.sendMessage,
    params: {
      mobile: mobile,
      clientType: 1,
      smsType: smsType,
      isVoice: isVoice,
      signCode: md5(`${smsType || ''}${1 || ''}${mobile || ''}${isVoice !== undefined ? isVoice : ''}`),
    }
  })
}
// 用户注销
export function onUserLogoff(req) {
  return request({
    method: 'get',
    url: API.onUserLogoff,
    params: req
  })
}
export function wxAuth() {
  return request({
    method: 'get',
    url: API.WxAuth,
    params: {
      userEnum: 'DOCTOR'
    }
  })
}

export function queryUvipToken(source, openId, sign, ts) {
  return request({
    method: 'get',
    url: API.getUvipToken,
    params: {
      source: source,
      openId: openId,
      sign: sign,
      ts: ts
    }
  })
}

export function checkDoctor() {
  return request({
    method: 'get',
    url: API.checkDoctor,
  })
}

export function checkDoctorBindStatus(representId = '', factoryIds = '') {
  return request({
    method: 'get',
    url: API.checkDoctorBindStatus,
    params: {
      representId: representId,
      factoryIds: factoryIds,
    }
  })
}
export function onRecallUserGift(req) {
  return request({
    method: 'post',
    url: API.onRecallUserGift,
    data: req
  })
}
export function getUserAccountInfo() {
  return request({
    method: 'get',
    url: API.getUserAccountInfo,
  })
}
export function getDoctorProblemList(params) {
  return request({
    method: 'get',
    url: API.ProblemList,
    params
  })
}

export function getGiftCount() {
  return request({
    url: API.doctorGift,
    method: 'get'
  })
}

export function getUvipGiftCount() {
  return request({
    url: API.UvipGift,
    method: 'get'
  })
}

export function byOrderList(pageNo = 1, state = '', pageSize = 10) {
  return request({
    method: 'get',
    url: API.getOrderList,
    params: {
      pageIndex: pageNo,
      pageSize: pageSize,
      orderType: state
    }
  })
}

export function getGiftRecord(params) {
  return request({
    method: 'get',
    url: API.GiftRecord,
    params
  })
}

export function getUvipGiftRecord(params) {
  return request({
    method: 'get',
    url: API.UvipGiftRecord,
    params
  })
}

export function getCommentDetail(id) {
  return request({
    method: 'get',
    url: API.getCommentDetail,
    params: {
      commentId: id
    }
  })
}
export function onReadProblem(id) {
  return request({
    url: API.ReadProblem,
    method: 'get',
    params: {
      commentId: id
    }
  })
}

export function replyProblem({ parentCommentId = '', content = '', sceneType = '', sceneId = '' }) {
  return request({
    method: 'post',
    url: API.doctorReply,
    params: {
      sceneId,
      sceneType,
      parentCommentId,
      content
    },
    // data: {
    // 	parentCommentId,
    // 	content,
    // 	sceneType,
    // 	sceneId
    // }
  })
}
export function sureReceive(id) {
  return request({
    method: 'get',
    url: API.sureReceive,
    params: {
      orderId: id
    }
  })
}

export function getOrderDetail(id) {
  return request({
    method: 'get',
    url: API.orderDetail,
    params: {
      orderId: id
    }
  })
}

export function onUploadImage(file, bucketType) {
  let params = new FormData()
  params.append('image', file)
  return request({
    url: API.onUploadImage,
    method: 'post',
    params: {
      bucketType: bucketType
    },
    data: params
  })
}

export function onOcrLicense(file) {
  let params = new FormData()
  params.append('image', file)
  return request({
    url: API.ocrLicense,
    method: 'post',
    data: params
  })
}

export function onSubmitSpeaker(data) {
  //讲者签约提交
  return request({
    url: API.onSubmitSpeaker,
    method: 'post',
    data
  })
}

export function getSpeakerGiftRecord(pageNo = 1, pageSize = 20, detailType = null) {
  return request({
    method: 'get',
    url: API.getSpeakerGiftRecord,
    params: {
      pageNo,
      pageSize,
      detailType
    }
  })
}

export function getUserImSig() {
  return request({
    url: API.getUserImSig,
    method: 'get'
  })
}
export function getUserFaceConfig(tmpId) {
  return request({
    method: 'get',
    url: API.getUserFaceConfig,
    params: { tmpId }
  })
}
export function getFaceAuthUrl(req) {
  return request({
    method: 'get',
    url: API.getFaceAuthUrl,
    params: req
  })
}
export function getFaceValidUrl(req) {
  return request({
    method: 'get',
    url: API.getFaceValidUrl,
    params: req
  })
}
export function getFaceAuthResult(orderNo = '') {
  return request({
    method: 'get',
    url: API.getFaceAuthResult,
    params: {
      bizToken: orderNo
    }
  })
}
export function getFaceValidResult(orderNo = '') {
  return request({
    method: 'get',
    url: API.getFaceValidResult,
    params: {
      orderNo: orderNo
    }
  })
}
export function uploadIdCardImage(data) {
  return request({
    url: API.uploadIdCardImage,
    method: 'post',
    data: data
  })
}
export function getIdCardInfo() {
  return request({
    method: 'get',
    url: API.getIdCardInfo
  })
}
export function getDoctorCertifyImage() {
  return request({
    method: 'get',
    url: API.getDoctorCertifyImage
  })
}
export function confirmModifyRecord(data) {
  return request({
    method: 'get',
    url: API.confirmModifyRecord,
    params: data
  })
}
export function getModifyRecordDetail(recordId) {
  return request({
    method: 'get',
    url: API.getModifyRecordDetail,
    params: {
      recordId
    }
  })
}
export function getModifyPharmacyDetail(data) {
  return request({
    method: 'get',
    url: API.getModifyPharmacyDetail,
    params: data
  })
}
export function submitPharmacyImage(data) {
  return request({
    method: 'post',
    url: API.submitPharmacyImage,
    data
  })
}
export function getPharmacyDetail() {
  return request({
    method: 'get',
    url: API.getPharmacyDetail
  })
}
export function onUpdatePharmacyInfo(data) {
  return request({
    method: 'post',
    url: API.onUpdatePharmacyInfo,
    data
  })
}
export function confirmPharmacyUserRecord(params) {
  return request({
    method: 'post',
    url: API.confirmPharmacyUserRecord,
    params
  })
}
export function confirmPharmacyRecord(params) {
  return request({
    method: 'post',
    url: API.confirmPharmacyRecord,
    params
  })
}
// 药店认证
export function changeRegisterType(data) {
  return request({
    method: 'post',
    url: API.changeRegisterType,
    params: data
  })
}

// 医院
export function onSearchHospital(hospitalName = '') {
  return request({
    method: 'get',
    url: API.onSearchHospital,
    params: {
      hospitalName
    }
  })
}

// 医院科室
export function onSearchDepartment(hospitalId = '') {
  return request({
    method: 'get',
    url: API.onSearchDepartment,
    params: {
      hospitalId
    }
  })
}

export function getWebSignUpUserInfo(id = '') {
  return request({
    method: 'get',
    url: API.getWebSignUpUserInfo,
    params: {
      id
    }
  })
}
export function onWebSignUp(req = {}) {
  return request({
    method: 'post',
    url: API.onWebSignUp,
    data: req
  })
}
export function getWebSignUpDetail(id = '') {
  return request({
    method: 'get',
    url: `${API.getWebSignUpDetail}/${id}`,
  })
}

// 高登暂时关闭，使用人力家认证
export function renlijiaAutor() {
  return request({
    method: 'get',
    url: API.renlijiaAutor
  })
}
export function getSpeakerFailInfo() {
  return request({
    method: 'get',
    url: API.getSpeakerFailInfo
  })
}
export function reSubmitSpeakerInfo(req) {
  return request({
    url: API.reSubmitSpeakerInfo,
    method: 'post',
    data: req
  })
}

export function uploadUserAvatar(data) {
  return request({
    url: API.uploadUserAvatar,
    method: 'post',
    data
  })
}

export function getCityInfo() {
  return request({
    method: 'get',
    url: API.cityInfo
  })
}

// 云智签约相关接口
export function getDoctorSignInfo() {
  return request({
    method: 'get',
    url: API.getDoctorSignInfo
  })
}

export function submitDoctorSign(data) {
  return request({
    method: 'post',
    url: API.submitDoctorSign,
    data
  })
}

export function confirmDoctorSign(signData) {
  return request({
    method: 'post',
    url: API.confirmDoctorSign,
    data: signData
  })
}
